$(document).ready(function() {
  var swiper = new Swiper(".trustpilot_right_col", {
    slidesPerView: 1,
    // spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      
      999: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      
      1199: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  });

 var position = $(".trustpilot_left_col").position();
  var adjustedLeft = position.left + 15;
  console.log(adjustedLeft);
  
  $('.trustpilot_right_inner_wrap').css('margin-right', '-' + adjustedLeft + 'px');
  $('.trustpilot_right_minus').css('padding-right', adjustedLeft + 'px');

  
});


// Syaing Us
$(document).ready(function(){
  $('.trusted_custom_img').owlCarousel({
    loop: false,
    margin: 25,
    nav: true,
    navText: [
      '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.5 1L1 6.5L6.5 12" stroke="black" stroke-width="1.15789"/> </svg>  ',
      '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 1L6 6.5L0.5 12" stroke="black" stroke-width="1.15789"/> </svg> '
    ],
    autoplay: false,
    items: 4,
    dots: false,
    responsive: {
      0: {
        items: 1,
        center: true,
        stagePadding: 40,
        loop: true,
        margin: 20,
       // nav: false,
       //  dots: true,
      },
      400: {
        items: 1,
        center: true,
        loop: true,
        margin: 20,
        stagePadding: 80,
        // nav: false,
        // dots: true,
      },
      600: {
        items: 3,
        center: false,
        loop: false,
        margin: 20,
        stagePadding: 0,
        // nav: false,
        // dots: true,
      },
      768: {
        items: 3,
        dots: false,
        nav: true,
      },
      1000: {
        items: 4,
        margin: 25,
      }
    }
  })


  if ($(window).width() <= 767){
      $('.blog_sec_slider').addClass('owl-carousel blog_sec_slide');
      $('.blog_sec_slide').owlCarousel({
        loop: true,
        margin: 24,
        nav: false,
        autoplay: false,
        dots: false,
        responsive: {
          0: {
            items: 1.2
          },
          650: {
            items:2
          }
        }
      })

      $('.text_icon_inner_sec').addClass('owl-carousel');
      $('.text_icon_inner_sec').owlCarousel({
          loop: true,
          margin: 24,
          nav: false,
          autoplay: true,
          autoplayTimeout:1500,
          autoplayHoverPause:false,
          autoplaySpeed: 800,
          dots: false,
          responsive: {
            0: {
              items: 2
            },
            600: {
              items:3
            }
          }
      })

      $('.week-day-step-main').addClass('owl-carousel');
      $('.week-day-step-main').owlCarousel({
          loop: true,
          margin: 24,
          nav: true,
          navText: [
            '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.5 1L1 6.5L6.5 12" stroke="black" stroke-width="1.15789"/> </svg>  ',
            '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 1L6 6.5L0.5 12" stroke="black" stroke-width="1.15789"/> </svg> '
          ],
          autoplay: false,
          autoplaySpeed: 800,
          dots: false,
          items: 1,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items:3
            }
          }
      })
      $('.how-it-bottom-div').addClass('owl-carousel');
      $('.how-it-bottom-div').owlCarousel({
          loop: true,
          margin: 24,
          nav: true,
          navText: [
            '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.5 1L1 6.5L6.5 12" stroke="black" stroke-width="1.15789"/> </svg>  ',
            '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 1L6 6.5L0.5 12" stroke="black" stroke-width="1.15789"/> </svg> '
          ],
          autoplay: false,
          autoplaySpeed: 800,
          dots: false,
          items: 1,autoHeight: true,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items:2
            }
          }
      })
      $('.key-ingredients-bottom').addClass('owl-carousel');
      $('.key-ingredients-bottom').owlCarousel({
          loop: true,
          margin: 24,
          nav: true,
          navText: [
            '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.5 1L1 6.5L6.5 12" stroke="black" stroke-width="1.15789"/> </svg>  ',
            '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 1L6 6.5L0.5 12" stroke="black" stroke-width="1.15789"/> </svg> '
          ],
          autoplay: false,
          autoplaySpeed: 800,
          dots: false,
          items: 1,
          autoHeight: true,
          responsive: {
            0: {
              items: 1
            },
            600: {
              items:2
            }
          }
      })
  }

function initFeatureBarCarousel() {
  var $featureBar = $('.feature_bar_wapper');

  if ($(window).width() <= 575) {
    if (!$featureBar.hasClass('owl-loaded')) {
      $featureBar.addClass('owl-carousel');
      $featureBar.owlCarousel({
        loop: false,
        nav: false,
        autoplay: true,
        dots: false,
        responsive: {
          0: {
            items: 1
          },
          650: {
            items: 2
          }
        }
      });
    }
  } else {
    if ($featureBar.hasClass('owl-loaded')) {
      $featureBar.trigger('destroy.owl.carousel');
      $featureBar.removeClass('owl-carousel owl-loaded');
      $featureBar.find('.owl-stage-outer').children().unwrap(); // remove owl markup
    }
  }
}

// Call on DOM ready
$(document).ready(function () {
  initFeatureBarCarousel();
});

// Call on resize
$(window).resize(function () {
  initFeatureBarCarousel();
});



  

    $('.logo_slide_wapper').addClass('owl-carousel');
    $('.logo_slide_wapper').owlCarousel({
      loop: true,
      nav: false,
      autoplay: true,
      items:6,
      dots: false,
      responsive: {
        0: {
          items: 2
        },
        425: {
          items: 3
        },
        650: {
          items:4
        },
        768: {
          items: 5
        },
        1200: {
          items: 6
        }
      }
    })


  
  
    $('.banner_inner_wapper').addClass('owl-carousel');
    $('.banner_inner_wapper').owlCarousel({
      loop: false,
      nav: true,
      autoplay: false,
      items: 1,
      nav: false,
      navText: [
        '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.5 1L1 6.5L6.5 12" stroke="black" stroke-width="1.15789"/> </svg>  ',
        '<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 1L6 6.5L0.5 12" stroke="black" stroke-width="1.15789"/> </svg> '
      ],
      dots: true,
      responsive: {
      768: {
        dots: false,
        nav: true,
        }
      }
    })
  
})


 document.addEventListener("DOMContentLoaded", function() {
  $(".custom-play-button").on("click", function(e) {
    const video = $(this).siblings("video")[0]; // Get the sibling video DOM element
    if (video) {
      video.play();
      $(this).hide(); // Hide the play button
    } else {
      console.error("Video element not found.");
    }
  });
});



$(document).ready(function () {
  $('.product_bundle_title').click(function () {
    var $tabBtn = $(this).closest('.tab-btn');
    var index = $tabBtn.data('index');
  
    // Close all other accordions and remove active class
    $('.tab-btn').removeClass('active');
    $('.product_bundle_details').slideUp();
  
    // Show clicked one
    if (!$tabBtn.hasClass('active')) {
      $tabBtn.addClass('active');
      $tabBtn.find('.product_bundle_details').slideDown();
  
      // Update product image on the right
      $('.product-pane').removeClass('active').hide();
      $('.product-pane[data-index="' + index + '"]').addClass('active').fadeIn();
    }
  });

  $('.product_list_item a').click(function () {
    var $tabBtn = $(this).closest('.product_list_item');
    var index = $tabBtn.data('index');
  
    // Close all other accordions and remove active class
    $('.product_list_item').removeClass('active');
  
    // Show clicked one
    if (!$tabBtn.hasClass('active')) {
      $tabBtn.addClass('active');
      // Update product image on the right
      $('.product_tab_list_item_data').removeClass('active').hide();
      $('.product_tab_list_item_data[data-index="' + index + '"]').addClass('active').fadeIn();
    }
  });
  
});

$(document).ready(function () {
  $(".faq_title").on("click", function () {
    $(this).parent().siblings().find(".faq_details").slideUp();
    $(this).parent().siblings().removeClass("active");
    $(this).parent().toggleClass("active");
    $(this).next(".faq_details").slideToggle();
  });
});

$(document).ready(function () {
  $(".mobile-acc-title").on("click", function () {
    $(this).parent().siblings().find(".mobile-acc-link-title").slideUp();
    $(this).parent().siblings().removeClass("active");
    $(this).parent().toggleClass("active");
    $(this).next(".mobile-acc-link-title").slideToggle();
  });
});

$(document).ready(function () {
$('.product-gallery_inner').slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});
});



















